import { render, staticRenderFns } from "./importView.vue?vue&type=template&id=1474dc9e&"
import script from "./importView.vue?vue&type=script&lang=js&"
export * from "./importView.vue?vue&type=script&lang=js&"
import style0 from "./importView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports